import { createAction } from 'redux-actions';

export const setShowFormActiom = createAction('PAGINA_COMPRA_SET_SHOW_FORM');

export const setBeneficiarioEditar = createAction('PAGINA_COMPRA_SET_BENEFICIARIO_EDITAR');
export const setIndexBeneficiairoEditar = createAction(
  'PAGINA_COMPRA_SET_INDEX_BENEFICIARIO_EDITAR',
);
